import { SECTION_IDS } from "./sections";

const hsl = (hex) => {
  const n = parseInt((hex || "#999999").slice(1), 16);
  const r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
  const mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn;
  if (!d) return { h: 0, s: 0, l };
  const h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
  return { h: ((h * 60) + 360) % 360, s: d / (1 - Math.abs(2 * l - 1)), l };
};

const tone = (p) => {
  const cols = (p.palette || []).map(hsl);
  const c = cols.find((x) => x.s > 0.18) || cols[0] || { h: 0, l: 0.5 };
  return c.h / 360 + c.l * 0.15;
};

export const colourFlow = (list) => [...list].sort((a, b) => tone(a) - tone(b));

export const curated = (paintings) =>
  SECTION_IDS.flatMap((id) => colourFlow(paintings.filter((p) => p.section === id))).concat(paintings.filter((p) => !SECTION_IDS.includes(p.section)));

export function justify(items, width, target, gap) {
  const ar = (p) => p.aspect_ratio || 1;
  const total = items.reduce((s, p) => s + ar(p), 0);
  const k = Math.max(1, Math.min(items.length, Math.round((total * target) / width)));
  const per = total / k;
  const rows = [];
  let row = [];
  let sum = 0;
  items.forEach((p, i) => {
    const left = items.length - i;
    if (row.length && rows.length < k - 1 && (sum + ar(p) / 2 > per || left < k - rows.length)) {
      rows.push(row);
      row = [];
      sum = 0;
    }
    row.push(p);
    sum += ar(p);
  });
  rows.push(row);
  const fill = (r) => (width - gap * (r.length - 1)) / r.reduce((a, p) => a + ar(p), 0);
  while (rows.length > 1 && fill(rows[rows.length - 1]) > target * 1.6) rows[rows.length - 2].push(...rows.pop());
  return rows.map((r) => {
    const s = r.reduce((a, p) => a + ar(p), 0);
    const h = (width - gap * (r.length - 1)) / s;
    return { h: Math.min(h, target * 1.6), items: r, last: h > target * 1.6 };
  });
}
